import { Dispatch, useCallback } from 'react'

export const useHandleClickCheck = (
  setValue: Dispatch<React.SetStateAction<boolean>>,
  value: boolean
) => {
  return useCallback(() => setValue(!value), [setValue, value])
}
